import { ChevronRight } from 'lucide-react';
import { Skeleton } from '@/components/ui';
import { SectionHeading } from './SectionHeading';

function SkeletonRow({ showDivider = false }: { showDivider?: boolean }) {
  return (
    <div
      className={[
        'flex items-center gap-3 px-4 py-3',
        showDivider ? 'border-b border-border' : '',
      ].join(' ')}
    >
      <Skeleton
        variant="circular"
        className="w-12 h-12 shrink-0"
      />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-3 w-20" />
      </div>
      <ChevronRight
        size={20}
        className="text-muted-foreground"
      />
    </div>
  );
}

/**
 * Body-only loading placeholder for the Settings list. The hero header
 * (hamburger + large "Settings" title) and page padding are owned by
 * SettingsMain, so this renders just the section groups.
 */
export function SettingsMainSkeleton() {
  return (
    <>
      {/* Account */}
      <SectionHeading>Account</SectionHeading>
      <div className="border border-border rounded-lg overflow-hidden mb-6">
        <SkeletonRow showDivider />
        <SkeletonRow />
      </div>

      {/* Household */}
      <SectionHeading>Household</SectionHeading>
      <div className="border border-border rounded-lg overflow-hidden mb-6">
        <SkeletonRow showDivider />
        <SkeletonRow showDivider />
        <SkeletonRow />
      </div>

      {/* Email Setup */}
      <SectionHeading>Email Setup</SectionHeading>
      <div className="border border-border rounded-lg overflow-hidden mb-6">
        <SkeletonRow showDivider />
        <SkeletonRow />
      </div>
    </>
  );
}
